import { atom } from 'recoil';

const activeItemAtom = atom<string | null>({
  key: 'activeItemAtom',
  default: null,
});
export default activeItemAtom;
